<script>
export default {
  props: {},
  inject: ['Accordion'],
  data() {
    return {
      index: null,
    };
  },
  computed: {
    visible() {
      return this.index == this.Accordion.active;
    },
  },
  methods: {
    open() {
      if (this.visible) {
        this.Accordion.active = null;
      } else {
        this.Accordion.active = this.index;
      }
    },
    start(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    end(el) {
      el.style.height = '';
    },
  },
  created() {
    this.index = this.Accordion.count++;
  },
};
</script>

<template>
  <div
    class="py-3 px-7 rounded-big-brand mb-2.5 bg-white"
    :class="{'shadow-brand': visible}"
  >
    <div
      class="relative flex items-center justify-between cursor-pointer"
      :class="{'text-green': visible}"
      @click="open"
    >
      <div
        class="accordion__trigger"
        :class="{'text-green': visible}"
      >
        <slot name="accordion-trigger"></slot>
      </div>
      <div
        class="block p-0 w-9 h-9 text-center text-3xl text-gray-700 rounded-full bg-gray-100 transform rotate-45 cursor-pointer transition duration-200 ease-in-out"
        :class="{'!text-white !bg-green rotate-0': visible}"
      >×</div>
    </div>
    <transition
      name="accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    >

      <div
        class="mt-2.5 accordion__content"
        v-show="visible"
      >
        <ul>
          <slot name="accordion-content"></slot>
        </ul>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.accordion__trigger {
  display: flex;
  justify-content: space-between;
}

.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>
